module.exports = __webpack_public_path__ + "static/media/hero-web.2f6e3251.jpg";